import { DefaultBadge } from "../../components/ui/badge";
import Workspace from "../../components/workspace";

const SMS = ({ sms, modal, SMSStatusBadge, setSelected }) => {
   return (
      <>
         <Workspace.ItemWrapper
            onClick={() => {
               setSelected(sms);
               modal.onOpen();
            }}>
            <div className="flex items-center px-4 py-5 gap-x-4 md:gap-x-6">
               <div className="grid gap-x-3 grid-cols-12 w-full items-center">
                  <div className="col-span-7 overflow-hidden overflow-ellipsis">
                     <p className="font-bold">{`${sms.receiver}`}</p>
                     <p className="mb-2">{sms.message.slice(0, 70)}...</p>
                  </div>
                  <div className="col-span-2">
                     <p>{new Date(sms.createdAt).toDateString()}</p>
                  </div>

                  <div className="col-span-3 flex justify-end gap-1 items-center" title="Delivery status">
                     {sms.groupId ? <DefaultBadge>Group</DefaultBadge> : null}
                     {sms.bulkId ? <DefaultBadge>Bulk</DefaultBadge> : null}
                     <SMSStatusBadge sms={sms} />
                  </div>
               </div>
            </div>
         </Workspace.ItemWrapper>
      </>
   );
};

export default SMS;
